"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sarsina": {
    "bf5b0d8f": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "campiano": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5d698fb": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "careste": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a959064": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "cerfoglio": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6c47cd4f": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "massa": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7bca5499": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "montalto": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e007e445": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "monteriolo": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff150adc": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "pagno": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a43b957d": [{
      "hkey": "eb27cdfa",
      "slug": "pieve-di-rivoschio",
      "name": "Pieve di Rivoschio",
      "primary": true,
      "skipSearch": false
    }],
    "rivoschio": [{
      "hkey": "eb27cdfa",
      "slug": "pieve-di-rivoschio",
      "name": "Pieve di Rivoschio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a42dc7f7": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "86d0f4e7",
      "slug": "sarsina",
      "name": "Sarsina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f55930c7": [{
      "hkey": "6e9106e9",
      "slug": "turrito-valbiano",
      "name": "Turrito-Valbiano",
      "primary": true,
      "skipSearch": false
    }],
    "turrito": [{
      "hkey": "6e9106e9",
      "slug": "turrito-valbiano",
      "name": "Turrito-Valbiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e12cb683": [{
      "hkey": "6e9106e9",
      "slug": "turrito-valbiano",
      "name": "Turrito-Valbiano",
      "primary": true,
      "skipSearch": false
    }],
    "valbiano": [{
      "hkey": "6e9106e9",
      "slug": "turrito-valbiano",
      "name": "Turrito-Valbiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sarsina"
    }]
  }
};
exports["default"] = _default;